import { render } from "./afterMovies.vue?vue&type=template&id=38932446"
const script = {}

import "./afterMovies.vue?vue&type=style&index=0&id=38932446&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__